import type { Role } from '@planning-session/shared';

const NAME_KEY = 'planning-session:name';
const ROLE_KEY = 'planning-session:role';
const tokenKey = (roomId: string) => `planning-session:token:${roomId}`;

/** localStorage throws in private modes and sandboxes; none of this is critical. */
function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* not important enough to surface */
  }
}

function remove(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* not important enough to surface */
  }
}

export const rememberedName = {
  get: () => read(NAME_KEY) ?? '',
  set: (name: string) => write(NAME_KEY, name),
};

export const rememberedRole = {
  get: (): Role => (read(ROLE_KEY) === 'observer' ? 'observer' : 'player'),
  set: (role: Role) => write(ROLE_KEY, role),
};

/** The seat secret, per room. Lets a reload land back in the same chair. */
export const seatToken = {
  get: (roomId: string) => read(tokenKey(roomId)) ?? undefined,
  set: (roomId: string, token: string) => write(tokenKey(roomId), token),
  clear: (roomId: string) => remove(tokenKey(roomId)),
};
